import { Button } from '@octopus-do/octopus-storybook'
import { CloudArrowUp } from '@octopus-do/octopus-storybook/icons'
import clsJoin from 'classnames'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onSave: () => void
  saving: boolean
}

// The header of a guest's report from the generator, not saved yet. Save is all
// it offers: the same blinking Save a guest's sitemap has in the editor, shown
// on a phone too — here there is nothing else on the header to make room for.
export const GuestHeader: React.FC<Props> = ({ onSave, saving }) => (
  <div className={css.header}>
    <div className={clsJoin(css.save, !saving && css.blink)}>
      <Button
        size="medium"
        label="Save"
        left={CloudArrowUp}
        loading={saving}
        onClick={onSave}
      />
    </div>
  </div>
)
